
// import React, { useState } from 'react';
// import { useNavigate } from 'react-router-dom';
// import axios from 'axios';

// const Snackbar = ({ message }) => {
//   return (
//     <div style={{
//       position: 'fixed',
//       bottom: '20px',
//       left: '50%',
//       transform: 'translateX(-50%)',
//       backgroundColor: '#333',
//       color: '#fff',
//       padding: '10px 20px',
//       borderRadius: '5px',
//       boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
//       zIndex: 1000,
//     }}>
//       {message}
//     </div>
//   );
// };

// const SignUp = () => {
//   const navigate = useNavigate();
//   const [name, setName] = useState('');
//   const [email, setEmail] = useState('');
//   const [companyName, setCompanyName] = useState('');
//   const [password, setPassword] = useState('');
//   const [snackbarMessage, setSnackbarMessage] = useState('');

//   const pageStyle = {
//     display: 'flex',
//     justifyContent: 'center',
//     alignItems: 'center',
//     height: '100vh',
//     background: '#000',
//     color: '#fff',
//     fontFamily: 'Arial, sans-serif',
//     margin: 0,
//     padding: 0,
//     boxSizing: 'border-box',
//   };

//   const containerStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     justifyContent: 'space-around',
//     alignItems: 'center',
//     background: '#111',
//     padding: '20px',
//     borderRadius: '10px 0px 0px 0px',
//     boxShadow: '0 0 20px 10px rgba(143, 0, 255, 0.5)',
//     width: '100%',
//     maxWidth: '599px',
//     height: '605px',
//     textAlign: 'center',
//     margin: '85px auto',
//     boxSizing: 'border-box',
//   };

//   const formStyle = {
//     display: 'flex',
//     flexDirection: 'column',
//     width: '100%',
//   };

//   const inputStyle = {
//     width: '100%',
//     padding: '10px',
//     margin: '10px 0',
//     border: '1px solid #333',
//     borderRadius: '5px',
//     background: '#222',
//     color: '#fff',
//     boxSizing: 'border-box',
//   };

//   const buttonStyle = {
//     width: '100%',
//     padding: '10px',
//     margin: '10px 0',
//     border: 'none',
//     borderRadius: '5px',
//     background: 'linear-gradient(90deg, rgba(58,29,132,1) 0%, rgba(123,36,203,1) 100%)',
//     color: '#fff',
//     cursor: 'pointer',
//     boxSizing: 'border-box',
//   };

//   const linkStyle = {
//     color: '#a2a2ff',
//     textDecoration: 'none',
//   };

//   const handleSignUp = async () => {
//     try {
//       const response = await axios.post('http://localhost:5000/signup', {
//         name,
//         email,
//         company_name: companyName,
//         password,
//       });

//       const { message, user_id } = response.data;
//       setSnackbarMessage(`Message: ${message}, User ID: ${user_id}`);
//       setTimeout(() => {
//         setSnackbarMessage('');
//         navigate('/');
//       }, 3000); // Hide snackbar after 3 seconds
//     } catch (error) {
//       setSnackbarMessage('Signup failed. Please try again.');
//       setTimeout(() => setSnackbarMessage(''), 3000); // Hide snackbar after 3 seconds
//     }
//   };

//   return (
//     <div style={pageStyle}>
//       <div style={containerStyle}>
//         <h2>Sign Up</h2>
//         <form style={formStyle} onSubmit={(e) => { e.preventDefault(); handleSignUp(); }}>
//           <input
//             type="text"
//             placeholder="Full name"
//             style={inputStyle}
//             value={name}
//             onChange={(e) => setName(e.target.value)}
//           />
//           <input
//             type="email"
//             placeholder="Email"
//             style={inputStyle}
//             value={email}
//             onChange={(e) => setEmail(e.target.value)}
//           />
//           <input
//             type="text"
//             placeholder="Company name"
//             style={inputStyle}
//             value={companyName}
//             onChange={(e) => setCompanyName(e.target.value)}
//           />
//           <input
//             type="password"
//             placeholder="Create password"
//             style={inputStyle}
//             value={password}
//             onChange={(e) => setPassword(e.target.value)}
//           />
//           <button type="submit" style={buttonStyle}>Sign Up</button>
//         </form>
//         <p>Already have an account? <a href="/" style={linkStyle}>Log In</a></p>
//       </div>
//       {snackbarMessage && <Snackbar message={snackbarMessage} />}
//     </div>
//   );
// };

// export default SignUp;


// axios instance 5000 code 
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axiosInstance5000 from '../services/5000AxiosInstance'; // Import the axios instance
import axios8000 from '../services/8000AxiosInstance';
import Snackbar from './Snackbar';


const SignUp = () => {
  const navigate = useNavigate();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [password, setPassword] = useState('');
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [processing, setProcessing] = useState(false); // State to track processing

  const pageStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    background: '#000',
    color: '#fff',
    fontFamily: 'Arial, sans-serif',
    margin: 0,
    padding: 0,
    boxSizing: 'border-box',
  };

  const containerStyle = {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-around',
    alignItems: 'center',
    background: '#111',
    padding: '20px',
    borderRadius: '10px 0px 0px 0px',
    boxShadow: '0 0 20px 10px rgba(143, 0, 255, 0.5)',
    width: '100%',
    maxWidth: '599px',
    height: '605px',
    textAlign: 'center',
    margin: '85px auto',
    boxSizing: 'border-box',
  };

  const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
  };

  const inputStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: '1px solid #333',
    borderRadius: '5px',
    background: '#222',
    color: '#fff',
    boxSizing: 'border-box',
  };

  const buttonStyle = {
    width: '100%',
    padding: '10px',
    margin: '10px 0',
    border: 'none',
    borderRadius: '5px',
    background: 'linear-gradient(90deg, rgba(58,29,132,1) 0%, rgba(123,36,203,1) 100%)',
    color: '#fff',
    cursor: processing ? 'not-allowed' : 'pointer', // Disable cursor if processing
    opacity: processing ? 0.6 : 1, // Dim button if processing
    boxSizing: 'border-box',
  };

  const linkStyle = {
    color: '#a2a2ff',
    textDecoration: 'none',
  };

  const handleSignUp = async () => {
    setProcessing(true); // Set processing to true
    try {
      const response = await axios8000.post('/signup', {
        name,
        email,
        company_name: companyName,
        password,
      });

      const { message, user_id } = response.data;
      setSnackbarMessage(`Message: ${message}, User ID: ${user_id}`);
      setTimeout(() => {
        setSnackbarMessage('');
        navigate('/');
      }, 3000); // Hide snackbar and navigate after 3 seconds
    } catch (error) {
      const errorMsg = error.response?.data?.message || 'Signup failed. Please try again.';
      setSnackbarMessage(errorMsg);
      setTimeout(() => setSnackbarMessage(''), 3000); // Hide snackbar after 3 seconds
    } finally {
      setProcessing(false); // Reset processing state
    }
  };

  return (
    <div style={pageStyle}>
      <div style={containerStyle}>
        <h2>Sign Up</h2>
        <form
          style={formStyle}
          onSubmit={(e) => {
            e.preventDefault();
            if (!processing) handleSignUp();
          }}
        >
          <input
            type="text"
            placeholder="Full name"
            style={inputStyle}
            value={name}
            onChange={(e) => setName(e.target.value)}
            disabled={processing} // Disable input if processing
          />
          <input
            type="email"
            placeholder="Email"
            style={inputStyle}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={processing} // Disable input if processing
          />
          <input
            type="text"
            placeholder="Company name"
            style={inputStyle}
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            disabled={processing} // Disable input if processing
          />
          <input
            type="password"
            placeholder="Create password"
            style={inputStyle}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            disabled={processing} // Disable input if processing
          />
          <button type="submit" style={buttonStyle} disabled={processing}>
            {processing ? 'Processing...' : 'Sign Up'}
          </button>
        </form>
        <p>
          Already have an account? <a href="/" style={linkStyle}>Log In</a>
        </p>
      </div>
      {snackbarMessage && <Snackbar message={snackbarMessage} />}
    </div>
  );
};

export default SignUp;